/* eslint-disable linebreak-style */
// device data management
export const FETCH_DEVICES = '@@device/fetch-devices';
export const SET_DEVICES = '@@device/set-devices';
export const SET_DEVICES_FAILURE = '@@device/set-devices-failure';
export const CLEAR_DEVICES = '@@device/clear-devices';

export const FETCH_DEVICE_DETAILS = '@@device/fetch-device-details';
export const SET_DEVICE_DETAILS = '@@device/set-device-details';
export const SET_DEVICE_DETAILS_FAILURE = '@@device/set-device-details-failure';
export const CLEAR_DEVICE_DETAILS = '@@device/clear-device-details';

export const UPDATE_DEVICE_STATUS = '@@device/update-device-status';
export const SET_DEVICE_STATUS_SUCCESS = '@@device/set-device-status-success';
export const SET_DEVICE_STATUS_FAILURE = '@@device/set-device-status-failure';

export const UPDATE_DEVICE_PROJECT = '@@device/update-device-project';
export const SET_DEVICE_PROJECT_SUCCESS = '@@device/set-device-project-success';
export const SET_DEVICE_PROJECT_FAILURE = '@@device/set-device-project-failure';

export const BULK_UPDATE_DEVICES = '@@device/bulk-update-devices';
export const SET_BULK_UPDATE_SUCCESS = '@@device/set-bulk-update-success';
export const SET_BULK_UPDATE_FAILURE = '@@device/set-bulk-update-failure';

export const FETCH_DEVICE_FILTERS = '@@device/fetch-device-filters';
export const SET_DEVICE_FILTERS = '@@device/set-device-filters';
export const SET_DEVICE_FILTERS_FAILURE = '@@device/set-device-filters-failure';

export const FETCH_DEVICE_STATS = '@@device/fetch-device-stats';
export const SET_DEVICE_STATS = '@@device/set-device-stats';
export const SET_DEVICE_STATS_FAILURE = '@@device/set-device-stats-failure';

export const DEVICE_REBOOT = '@@device/device-reboot';
export const SET_DEVICE_REBOOT_SUCCESS = '@@device/set-device-reboot-success';
export const SET_DEVICE_REBOOT_FAILURE = '@@device/set-device-reboot-failure';

export const DEVICE_FIRMWARE_UPDATE = '@@device/device-firmware-update';
export const SET_DEVICE_FIRMWARE_UPDATE_SUCCESS = '@@device/set-device-firmware-update-success';
export const SET_DEVICE_FIRMWARE_UPDATE_FAILURE = '@@device/set-device-firmware-update-failure';

export const FETCH_DEVICE_LOGS = '@@device/fetch-device-logs';
export const SET_DEVICE_LOGS = '@@device/set-device-logs';
export const SET_DEVICE_LOGS_FAILURE = '@@device/set-device-logs-failure';
export const CLEAR_DEVICE_LOGS = '@@device/clear-device-logs';

// Communication Check Actions
export const CHECK_COMMUNICATION = '@@device/check-communication';
export const SET_COMMUNICATION_SUCCESS = '@@device/set-communication-success';
export const SET_COMMUNICATION_FAILURE = '@@device/set-communication-failure';
export const CLEAR_COMMUNICATION_DATA = '@@device/clear-communication-data';
export const SET_COMMUNICATION_RESPONSE_TIME = '@@device/set-communication-response-time';
export const START_COMMUNICATION_TIMER = '@@device/start-communication-timer';

// Get All Devices Actions
export const GET_ALL_DEVICES = '@@device/get-all-devices';
export const SET_ALL_DEVICES_SUCCESS = '@@device/set-all-devices-success';
export const SET_ALL_DEVICES_FAILURE = '@@device/set-all-devices-failure';

// Device Time Management Actions
export const SET_DEVICE_TIME_DETAILS = '@@device/set-device-time-details';
export const GET_DEVICE_TIME_DETAILS = '@@device/get-device-time-details';
export const SET_DEVICE_TIME_SUCCESS = '@@device/set-device-time-success';
export const SET_DEVICE_TIME_FAILURE = '@@device/set-device-time-failure';
export const SET_DEVICE_TIME_SET_SUCCESS = '@@device/set-device-time-set-success';
export const SET_DEVICE_TIME_SET_FAILURE = '@@device/set-device-time-set-failure';
export const CLEAR_DEVICE_TIME_DATA = '@@device/clear-device-time-data';

// Device Logs Management Actions
export const CHECK_NUMBER_LOGS = '@@device/check-number-logs';
export const ERASE_LOGS = '@@device/erase-logs';
export const SET_LOGS_SUCCESS = '@@device/set-logs-success';
export const SET_LOGS_FAILURE = '@@device/set-logs-failure';
export const SET_ERASE_LOGS_SUCCESS = '@@device/set-erase-logs-success';
export const SET_ERASE_LOGS_FAILURE = '@@device/set-erase-logs-failure';

// Reset MQTT Event
export const RESET_MQTT_EVENT = '@@device/reset-mqtt-event';
export const SET_RESET_MQTT_EVENT_SUCCESS = '@@device/set-reset-mqtt-event-success';
export const SET_RESET_MQTT_EVENT_FAILURE = '@@device/set-reset-mqtt-event-failure';

// Weld Parameters Actions
export const WELDPARAMS = '@@device/weld-params';
export const LOCATION = '@@device/location';
export const PASSWORD_PROTECTION = '@@device/password-protection';
export const SET_WELD_PARAMS_SUCCESS = '@@device/set-weld-params-success';
export const SET_WELD_PARAMS_FAILURE = '@@device/set-weld-params-failure';
export const SET_LOCATION_SUCCESS = '@@device/set-location-success';
export const SET_LOCATION_FAILURE = '@@device/set-location-failure';
export const CLEAR_DEVICE_OPERATIONS_DATA = '@@device/clear-device-operations-data';

// Device Status Update Actions
export const UPDATE_DEVICE_OPERATION_STATUS = '@@device/update-device-operation-status';
export const SET_DEVICE_OPERATION_STATUS_SUCCESS = '@@device/set-device-operation-status-success';
export const SET_DEVICE_OPERATION_STATUS_FAILURE = '@@device/set-device-operation-status-failure';

// Communication Polling Actions
export const START_COMMUNICATION_POLLING = '@@device/start-communication-polling';
export const STOP_COMMUNICATION_POLLING = '@@device/stop-communication-polling';
export const POLL_COMMUNICATION_STATUS = '@@device/poll-communication-status';
export const SET_POLLING_STATUS = '@@device/set-polling-status';
export const UPDATE_POLLING_PROGRESS = '@@device/update-polling-progress';

// Project List Actions
export const FETCH_PROJECT_LIST = '@@device/fetch-project-list';
export const SET_PROJECT_LIST = '@@device/set-project-list';
export const SET_PROJECT_LIST_FAILURE = '@@device/set-project-list-failure';
export const FETCH_DEVICE_PROJECT_LIST = '@@device/fetch-device-project-list';
export const SET_DEVICE_PROJECT_LIST = '@@device/set-device-project-list';
export const SET_DEVICE_PROJECT_LIST_FAILURE = '@@device/set-device-project-list-failure';

// Rename Pass Actions
export const RENAME_PASS = '@@device/rename-pass';
export const SET_RENAME_PASS_SUCCESS = '@@device/set-rename-pass-success';
export const SET_RENAME_PASS_FAILURE = '@@device/set-rename-pass-failure';

// Firmware Update Device Tracking Actions
export const ADD_FIRMWARE_UPDATE_DEVICE = '@@device/add-firmware-update-device';
export const REMOVE_FIRMWARE_UPDATE_DEVICE = '@@device/remove-firmware-update-device';
export const CLEAR_FIRMWARE_UPDATE_DEVICES = '@@device/clear-firmware-update-devices';

// Firmware Update Polling Actions
export const START_FIRMWARE_UPDATE_POLLING = '@@device/start-firmware-update-polling';
export const STOP_FIRMWARE_UPDATE_POLLING = '@@device/stop-firmware-update-polling';
export const UPDATE_FIRMWARE_UPDATE_PROGRESS = '@@device/update-firmware-update-progress';
export const SET_FIRMWARE_UPDATE_PROGRESS = '@@device/set-firmware-update-progress';
export const CLEAR_FIRMWARE_UPDATE_PROGRESS = '@@device/clear-firmware-update-progress';